/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'map-navigation/turn-around': {
    width: 16,
    height: 16,
    viewBox: '0 0 98 98',
    data: '<g data-name="Layer 2"><g data-name="Layer 1"><rect pid="0" width="98" height="98" rx="3.02" _fill="#373a36"/><path pid="1" d="M35.64 78.94l-24.74-23v-13l19.8 18.4V24.5h9.9v36.84l19.79-18.41v13z" _fill="#fff"/><path pid="2" _fill="#fff" d="M32.66 24.5h39.93v10.89H32.66z"/><path pid="3" _fill="#fff" d="M70.78 24.5h10.89v39.93H70.78z"/></g></g>'
  }
})
